







































import { Component, Vue, Prop } from 'vue-property-decorator';
import Button from '@/components/Button.vue';
import LoaderCircular from '@/components/LoaderCircular.vue';
import { EModalSize } from '@/modal/types/modal-size';
import Icon from '@/components/Icon.vue';

@Component({
  components: {
    Button,
    LoaderCircular,
    Icon,
  },
})
export default class OldModal extends Vue {
  @Prop() title?: string;
  @Prop() error?: string;
  @Prop() buttonText?: string;

  @Prop({ default: true }) closable?: boolean;
  @Prop({ default: true }) isLoading?: boolean;
  @Prop({ default: true }) padded?: boolean;
  @Prop({ default: true }) showDefaultFooter?: boolean;
  @Prop() smallDeviceFullscreen?: boolean;
  @Prop() mobileHeader?: string;
  @Prop() useTitleAsMobileHeader?: boolean;
  @Prop({ default: false }) stickyMobileFooter: boolean;

  @Prop({ default: EModalSize.medium }) size?: EModalSize;

  get displayButtonText(): string {
    return this.buttonText || this.$t('Ok').toString();
  }

  get footerHasContent(): boolean {
    return !!this.$slots.footer;
  }

  get transition(): 'fullscreen' | 'modal' {
    return this.smallDeviceFullscreen ? 'fullscreen' : 'modal';
  }

  get header(): string {
    return this.useTitleAsMobileHeader ? this.title : this.mobileHeader;
  }

  handleClose() {
    if (this.closable) {
      this.$emit('close');
    }
  }

  mounted() {
    window.addEventListener('keyup', (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        this.handleClose();
      }
    });
  }

  destroyed() {
    window.removeEventListener('keyup', (e: KeyboardEvent) => {
      if (e.key === 'Escaped') {
        this.handleClose();
      }
    });
  }
}
